import { Client } from "@/Common/Api/Client";
import { ClientResponse } from "@/Common/Api/ClientResponse";
import { LoadPatientModel } from "@/Common/Api/Patient/Dto/LoadPatientModel";
import * as ServerOperations from "@/Common/Operations/operations.server";

class PatientApiClient {
    public static loadPatientInfo(individualId: string, includeRelatedRecalls: boolean, includeRelationships: boolean): Promise<ClientResponse<LoadPatientModel>> {
        return Client.postAsync(ServerOperations.Server.Myle_LoadPatient, { individualId, includeRelatedRecalls, includeRelationships });
    }
}

export { PatientApiClient };
